import React from 'react'
import { Button } from '../../../components/Button/Button'

interface UserActionButtonProps {
  icon: React.ReactNode
  label: string
  onClick: () => void
}

export const UserActionButton: React.FC<UserActionButtonProps> = ({ icon, label, onClick }) => {
  return (
    <Button className='d-flex align-items-center gap-2 zocks-px-0.75 rounded-pill border zocks-border-color-primary' onClick={onClick}>
      {icon}
      <span>{label}</span>
    </Button>
  )
}
